import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const loadCustomerFilesQueryAtom = createQueryAtomFactory(
  'customerPortal.loadCustomerFiles',
  (params: { id?: string }) => ({
    load: {
      __args: {
        id: params.id ?? '',
      },
      customerFiles: {
        id: true,
        entityType: true,
        metadata: true,
        fileName: true,
        fileSize: true,
        mimeType: true,
      },
    },
  }),
  {
    select: ({ load }) => load?.customerFiles ?? [],
  },
);
